(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[851,65250],{

/***/ 851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WideFormatPrinterCostsWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/styles/variables/wideformatprintercostsVariables.module.scss
var wideformatprintercostsVariables_module = __webpack_require__(75321);
var wideformatprintercostsVariables_module_default = /*#__PURE__*/__webpack_require__.n(wideformatprintercostsVariables_module);
;// CONCATENATED MODULE: ./src/components/wideformatprintercosts/logo/index.tsx


function WideFormatPrinterCostsLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "318",
        height: "25",
        fill: "none",
        viewBox: "0 0 318 25",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_3_2)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M28.534 5.151h3.103l3.208 11.99.449 1.759h.14l.519-1.759 3.103-9.493h2.76l3.103 9.493.528 1.759h.149l.396-1.759 3.05-11.99h3.094l-4.958 18.671H44.26l-3.209-9.836-.545-1.846h-.158l-.518 1.846-3.235 9.836h-2.919l-5.142-18.67zM55.186 8.852a1.899 1.899 0 01-1.397-.571 2.004 2.004 0 010-2.77 1.899 1.899 0 011.397-.57 1.872 1.872 0 011.372.57 1.987 1.987 0 010 2.77 1.872 1.872 0 01-1.372.571zm-1.459 14.944V11.05h2.892v12.772l-2.892-.026zM69.295 22.178h-.158a4.333 4.333 0 01-1.591 1.442c-.78.428-1.66.64-2.55.615a5.495 5.495 0 01-2.338-.51 5.916 5.916 0 01-1.943-1.415 7.033 7.033 0 01-1.327-2.153 7.656 7.656 0 010-5.45 6.944 6.944 0 011.328-2.154 6.065 6.065 0 011.969-1.424 5.616 5.616 0 012.338-.501 5.09 5.09 0 012.55.606c.642.344 1.188.843 1.59 1.45h.158l-.158-1.757V5.15h2.901v18.671h-2.743l-.026-1.644zm-3.754-.58c.49-.001.974-.1 1.425-.29.45-.184.857-.46 1.195-.809.356-.373.636-.812.826-1.292a5.028 5.028 0 000-3.463 3.84 3.84 0 00-.826-1.293 3.515 3.515 0 00-1.195-.808 3.684 3.684 0 00-1.424-.29 3.596 3.596 0 00-1.433.29 3.516 3.516 0 00-1.187.817 4.228 4.228 0 00-.826 1.292 4.976 4.976 0 000 3.446c.192.476.472.912.826 1.284a3.4 3.4 0 001.187.826c.452.194.94.293 1.433.29zM86.665 20.772a6.91 6.91 0 01-2.294 2.47 6.373 6.373 0 01-3.648.993 6.742 6.742 0 01-2.638-.51 6.152 6.152 0 01-2.092-1.415 6.576 6.576 0 01-1.389-2.153 7.692 7.692 0 010-5.345c.301-.8.749-1.536 1.319-2.171a6.154 6.154 0 012.048-1.468 6.274 6.274 0 012.637-.545c.904-.018 1.801.15 2.637.492a5.73 5.73 0 011.97 1.38c.54.624.95 1.35 1.204 2.136.292.885.437 1.811.43 2.743v.237a1.148 1.148 0 000 .229.887.887 0 000 .21h-9.862a4.006 4.006 0 001.327 2.717c.353.287.755.508 1.187.65.411.134.841.203 1.274.203a3.367 3.367 0 002.066-.598 5.01 5.01 0 001.327-1.486l2.497 1.23zm-2.69-4.932a3.463 3.463 0 00-.246-.879 2.558 2.558 0 00-.598-.879 3.445 3.445 0 00-1.046-.694 3.709 3.709 0 00-1.547-.29 3.287 3.287 0 00-2.154.747 3.667 3.667 0 00-1.213 1.995h6.804zM89.478 5.151h11.375v2.813h-8.43v5.345h7.595v2.769h-7.595v7.744h-2.945V5.152zM108.307 10.628c.921-.011 1.835.16 2.69.5.793.327 1.511.811 2.11 1.425.6.62 1.07 1.356 1.38 2.162a7.59 7.59 0 010 5.424 6.549 6.549 0 01-1.38 2.171 6.163 6.163 0 01-2.11 1.415 6.883 6.883 0 01-2.69.51 6.811 6.811 0 01-2.681-.51 6.16 6.16 0 01-2.119-1.415 6.689 6.689 0 01-1.38-2.171 7.72 7.72 0 010-5.424 6.553 6.553 0 011.38-2.162 6.341 6.341 0 012.119-1.424 6.97 6.97 0 012.681-.501zm0 10.926a3.51 3.51 0 001.406-.29 3.745 3.745 0 001.213-.809c.38-.365.679-.805.88-1.292a5.03 5.03 0 000-3.463 3.659 3.659 0 00-.88-1.292 3.745 3.745 0 00-1.213-.81 3.51 3.51 0 00-2.813 0 3.767 3.767 0 00-1.213.81c-.386.359-.686.8-.879 1.292a4.896 4.896 0 000 3.463c.197.489.497.93.879 1.292.348.346.76.621 1.213.809.441.208.92.321 1.407.334v-.044zM116.913 11.05h2.742v1.933h.167c.164-.342.38-.657.642-.931a4.34 4.34 0 01.879-.73 5.268 5.268 0 011.064-.492c.35-.126.718-.191 1.09-.194.358-.008.715.03 1.063.115.283.072.555.181.809.325l-.835 2.637a2.798 2.798 0 00-.633-.202 4.772 4.772 0 00-.879-.062 2.903 2.903 0 00-1.292.29c-.39.193-.739.459-1.029.783a3.508 3.508 0 00-.685 1.178 4.17 4.17 0 00-.255 1.441v6.69h-2.892l.044-12.781zM126.951 11.05h2.743v1.758h.15a4.626 4.626 0 011.67-1.539 4.78 4.78 0 014.738.062 3.885 3.885 0 011.494 1.758 5.683 5.683 0 011.758-1.705 4.87 4.87 0 012.637-.686 4.959 4.959 0 012.031.378 3.725 3.725 0 011.424 1.055c.398.478.697 1.031.879 1.626.201.69.299 1.408.29 2.127v8.008h-2.892v-7.568a3.354 3.354 0 00-.642-2.33 2.449 2.449 0 00-1.863-.668 2.507 2.507 0 00-1.266.317c-.38.215-.706.516-.949.879a4.051 4.051 0 00-.607 1.24 5.167 5.167 0 00-.264 1.44v6.629h-2.9v-7.507a3.26 3.26 0 00-.66-2.33 2.58 2.58 0 00-1.916-.668 2.42 2.42 0 00-1.231.317 3.054 3.054 0 00-.94.879 4.273 4.273 0 00-.598 1.24 5.092 5.092 0 00-.193 1.44v6.629h-2.893V11.05zM157.489 22.257h-.158a6.03 6.03 0 01-1.468 1.363 4.034 4.034 0 01-2.321.615 5.385 5.385 0 01-1.898-.325 4.557 4.557 0 01-1.539-.88 4.316 4.316 0 01-1.054-1.432 4.302 4.302 0 010-3.586 3.804 3.804 0 011.125-1.354 5.278 5.278 0 011.705-.88 7.562 7.562 0 012.136-.298 8.223 8.223 0 012.145.246c.443.125.877.277 1.301.457v-.492a2.374 2.374 0 00-.246-1.073 2.737 2.737 0 00-.677-.879 3.256 3.256 0 00-.984-.545 3.326 3.326 0 00-1.143-.202 3.943 3.943 0 00-1.758.378 3.71 3.71 0 00-1.372 1.213l-2.294-1.512a5.884 5.884 0 012.268-1.89 7.182 7.182 0 013.077-.632 6.303 6.303 0 014.395 1.406 5.136 5.136 0 011.547 4.017v7.771h-2.839l.052-1.486zm0-3.762a5.987 5.987 0 00-1.274-.545 5.678 5.678 0 00-1.618-.21 3.402 3.402 0 00-2.162.632 1.83 1.83 0 00-.809 1.512c-.008.286.062.569.202.817.14.237.322.445.537.616.223.178.48.31.756.387.284.087.581.131.879.131.457.015.912-.066 1.336-.237a3.51 3.51 0 001.107-.73c.315-.302.571-.66.756-1.054.199-.411.298-.863.29-1.319zM164.188 13.599h-2.242v-2.55h2.242V7.13h2.901v3.92h3.155v2.55h-3.155v5.837a3.52 3.52 0 00.105.879c.054.242.159.47.308.668a1.437 1.437 0 001.125.51c.219.005.438-.02.65-.07.17-.049.335-.114.493-.194l.879 2.558a6.858 6.858 0 01-2.479.448 4.247 4.247 0 01-1.618-.29 3.984 3.984 0 01-1.222-.8 4.265 4.265 0 01-1.125-3.112l-.017-6.434zM173.057 23.822V5.152h6.47a6.549 6.549 0 012.356.412 5.962 5.962 0 011.943 1.178 5.596 5.596 0 011.347 6.39 5.596 5.596 0 01-1.347 1.873 5.944 5.944 0 01-1.943 1.17 6.55 6.55 0 01-2.356.421h-3.516v7.226h-2.954zm6.54-10.039c.447.006.89-.08 1.301-.255.364-.151.693-.376.967-.659.253-.276.455-.595.598-.94a2.747 2.747 0 000-2.11 2.967 2.967 0 00-.598-.932 3.183 3.183 0 00-.967-.66 3.1 3.1 0 00-1.301-.263h-3.604v5.82h3.604zM187.711 11.05h2.743v1.933h.158a3.56 3.56 0 01.633-.931c.259-.281.555-.527.879-.73a5.376 5.376 0 011.072-.492 3.205 3.205 0 011.081-.194c.358-.008.716.03 1.064.115.283.07.555.18.809.325l-.835 2.637a2.647 2.647 0 00-.633-.202 4.779 4.779 0 00-.879-.062 2.844 2.844 0 00-1.284.29 3.34 3.34 0 00-1.037.783 3.646 3.646 0 00-.686 1.178 4.19 4.19 0 00-.246 1.441v6.69h-2.901l.062-12.781zM199.42 8.852a1.896 1.896 0 01-1.398-.571 2.005 2.005 0 010-2.77 1.9 1.9 0 011.398-.57 1.855 1.855 0 011.371.57 1.988 1.988 0 010 2.77 1.856 1.856 0 01-1.371.571zm-1.459 14.944V11.05h2.892v12.772l-2.892-.026zM206.725 12.808h.123a4.626 4.626 0 011.626-1.53 4.709 4.709 0 012.382-.606 4.443 4.443 0 013.631 1.441 5.846 5.846 0 011.195 3.85v7.912h-2.857v-7.551a2.541 2.541 0 00-.639-2.2 2.55 2.55 0 00-2.147-.798 2.733 2.733 0 00-1.336.317 3.11 3.11 0 00-.985.879 3.719 3.719 0 00-.633 1.23 5.17 5.17 0 00-.202 1.442v6.68h-2.901V11.05h2.743v1.758zM219.295 13.599h-2.242v-2.55h2.242V7.13h2.892v3.92h3.121v2.55h-3.156v5.837a3.52 3.52 0 00.105.879c.062.24.166.466.308.668a1.464 1.464 0 001.125.51c.398.016.792-.075 1.143-.264l.879 2.558c-.371.141-.753.25-1.143.325-.446.082-.9.12-1.353.114a4.183 4.183 0 01-1.618-.29 3.913 3.913 0 01-1.231-.8 4.245 4.245 0 01-1.116-3.111l.044-6.426zM239.451 20.772a6.907 6.907 0 01-2.294 2.47 6.389 6.389 0 01-3.657.993 6.726 6.726 0 01-2.637-.51 6.15 6.15 0 01-2.092-1.415 6.567 6.567 0 01-1.389-2.153 7.69 7.69 0 010-5.345c.301-.8.748-1.536 1.319-2.171a6.148 6.148 0 012.048-1.468 6.274 6.274 0 012.637-.545 6.635 6.635 0 012.637.492 5.723 5.723 0 011.969 1.38 6.166 6.166 0 011.24 2.136c.292.885.437 1.811.43 2.743v.237a1.246 1.246 0 000 .229.93.93 0 000 .21h-9.889a4.01 4.01 0 00.448 1.592c.22.427.518.808.88 1.125.352.287.754.508 1.186.65a4.11 4.11 0 001.275.203 3.369 3.369 0 002.066-.598 5.021 5.021 0 001.327-1.486l2.496 1.23zm-2.716-4.932a3.446 3.446 0 00-.246-.879 2.546 2.546 0 00-.598-.879 3.433 3.433 0 00-1.046-.694 3.707 3.707 0 00-1.547-.29 3.288 3.288 0 00-2.154.747 3.666 3.666 0 00-1.213 1.995h6.804zM241.851 11.05h2.734v1.933h.158c.164-.342.38-.657.642-.931.258-.283.554-.529.879-.73a5.268 5.268 0 011.064-.492c.347-.125.712-.19 1.081-.194.361-.007.721.03 1.072.115.283.072.555.181.809.325l-.835 2.637a2.742 2.742 0 00-.642-.202 4.664 4.664 0 00-.879-.062 2.85 2.85 0 00-1.292.29c-.391.19-.741.457-1.028.783a3.663 3.663 0 00-.695 1.178 4.19 4.19 0 00-.246 1.441v6.69h-2.892l.07-12.781zM268.574 20.868a9.486 9.486 0 01-3.2 2.488 9.709 9.709 0 01-4.228.88 9.94 9.94 0 01-3.859-.74 9.494 9.494 0 01-5.151-5.15 10.319 10.319 0 010-7.71 9.62 9.62 0 012.057-3.103 9.445 9.445 0 013.094-2.057 9.779 9.779 0 013.859-.747 9.094 9.094 0 013.886.8 9.203 9.203 0 013.024 2.25l-2.084 2.04a6.43 6.43 0 00-2.101-1.697 6.01 6.01 0 00-2.725-.571 7.251 7.251 0 00-2.637.475 6.231 6.231 0 00-2.154 1.389 6.621 6.621 0 00-1.45 2.188 8.123 8.123 0 000 5.758 6.74 6.74 0 001.45 2.198 6.34 6.34 0 002.154 1.38 7.252 7.252 0 002.637.483 6.15 6.15 0 002.971-.694 7.598 7.598 0 002.321-1.917l2.136 2.057zM276.398 10.628a7.03 7.03 0 012.689.5c.793.327 1.511.811 2.11 1.425a6.567 6.567 0 011.389 2.162 7.72 7.72 0 010 5.424 6.703 6.703 0 01-1.389 2.171 6.144 6.144 0 01-2.11 1.415 7.329 7.329 0 01-5.37 0 6.153 6.153 0 01-2.11-1.415 6.565 6.565 0 01-1.389-2.171 7.72 7.72 0 010-5.424 6.432 6.432 0 011.389-2.162 6.296 6.296 0 012.11-1.424 7.029 7.029 0 012.681-.501zm0 10.926a3.58 3.58 0 001.415-.29 3.743 3.743 0 002.057-2.1 4.896 4.896 0 000-3.464 3.755 3.755 0 00-.879-1.292 3.964 3.964 0 00-1.213-.81 3.58 3.58 0 00-2.822 0 3.964 3.964 0 00-1.213.81 3.74 3.74 0 00-.879 1.292 4.896 4.896 0 000 3.463 3.73 3.73 0 002.057 2.101c.463.216.966.33 1.477.334v-.044zM289.988 24.235a6.835 6.835 0 01-2.11-.307 6.004 6.004 0 01-1.644-.827 5.135 5.135 0 01-1.151-1.16 5.404 5.404 0 01-.748-1.354l2.638-1.099c.24.674.686 1.255 1.274 1.662a3.332 3.332 0 001.802.527 2.925 2.925 0 001.758-.44 1.14 1.14 0 00.524-1.495 1.156 1.156 0 00-.365-.447 4.507 4.507 0 00-1.759-.72l-1.828-.44a6.35 6.35 0 01-1.213-.405 5.073 5.073 0 01-1.134-.703 3.514 3.514 0 01-.879-1.046 2.97 2.97 0 01-.325-1.442 3.332 3.332 0 01.404-1.67 3.516 3.516 0 011.108-1.23 5.43 5.43 0 011.626-.756 7.507 7.507 0 011.969-.255c.558 0 1.115.058 1.661.175a5.74 5.74 0 011.468.554 4.39 4.39 0 011.213.88c.376.377.675.825.879 1.318l-2.558 1.063a2.354 2.354 0 00-1.151-1.213 3.674 3.674 0 00-1.591-.378 3.107 3.107 0 00-.739.097c-.235.055-.463.141-.676.255a1.75 1.75 0 00-.501.43.936.936 0 00-.194.58.932.932 0 00.457.818c.434.253.906.434 1.398.537l1.951.492a5.82 5.82 0 012.91 1.503c.602.636.932 1.48.923 2.356a3.303 3.303 0 01-.378 1.565 3.99 3.99 0 01-1.081 1.31 5.372 5.372 0 01-1.679.878 6.707 6.707 0 01-2.259.387zM298.646 13.599h-2.241v-2.55h2.241V7.13h2.892v3.92h3.156v2.55h-3.156v5.837a3.52 3.52 0 00.106.879c.06.241.168.468.316.668a1.425 1.425 0 001.117.51c.219.006.437-.018.65-.07a2.76 2.76 0 00.501-.194l.879 2.558a6.696 6.696 0 01-2.505.44 4.213 4.213 0 01-1.618-.29 3.875 3.875 0 01-1.221-.8 4.24 4.24 0 01-1.126-3.112l.009-6.426zM312.201 24.235a6.835 6.835 0 01-2.11-.307 6.145 6.145 0 01-1.643-.827 5.382 5.382 0 01-1.926-2.514l2.638-1.099a3.37 3.37 0 001.283 1.662c.524.339 1.134.522 1.758.527a2.893 2.893 0 001.758-.44 1.14 1.14 0 00.523-1.495 1.138 1.138 0 00-.365-.447 4.497 4.497 0 00-1.758-.72l-1.819-.44a5.94 5.94 0 01-1.213-.405 4.687 4.687 0 01-1.134-.703 3.4 3.4 0 01-.879-1.046 3.08 3.08 0 01-.326-1.442 3.333 3.333 0 01.405-1.67c.271-.488.65-.909 1.107-1.23.5-.34 1.052-.596 1.635-.756a7.807 7.807 0 013.622-.08 5.956 5.956 0 011.477.554c.448.227.858.524 1.213.88.373.38.671.827.879 1.318l-2.558 1.063a2.339 2.339 0 00-1.143-1.213 3.735 3.735 0 00-1.591-.378 3.172 3.172 0 00-1.424.352c-.191.11-.358.256-.492.43a.944.944 0 00-.035 1.125c.076.11.175.204.29.273.434.252.906.432 1.397.537l1.961.492a5.788 5.788 0 012.9 1.503 3.34 3.34 0 01.932 2.356 3.394 3.394 0 01-.378 1.565 4.23 4.23 0 01-1.081 1.31 5.5 5.5 0 01-1.688.878 6.669 6.669 0 01-2.215.387z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#231F20",
                        d: "M11.234 4.061H1.521C.68 4.061 0 4.742 0 5.581v9.714c0 .84.68 1.521 1.52 1.521h9.714c.84 0 1.52-.68 1.52-1.52V5.581c0-.84-.68-1.52-1.52-1.52z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#168FCE",
                        d: "M19.99 12.245h-9.714c-.84 0-1.52.681-1.52 1.52v9.714c0 .84.68 1.521 1.52 1.521h9.713c.84 0 1.521-.68 1.521-1.52v-9.714c0-.84-.68-1.52-1.52-1.52z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_3_2)",
                        d: "M9.344 14.205v8.826c0 .762.618 1.38 1.38 1.38h8.826a1.38 1.38 0 001.38-1.38v-8.826a1.38 1.38 0 00-1.38-1.38h-8.826a1.38 1.38 0 00-1.38 1.38z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_3_2)",
                        d: "M.589 6.021v8.826c0 .762.618 1.38 1.38 1.38h8.826a1.38 1.38 0 001.38-1.38V6.021a1.38 1.38 0 00-1.38-1.38H1.969a1.38 1.38 0 00-1.38 1.38z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F3EA00",
                        d: "M19.392 18.328h-3.683a.571.571 0 00-.572.571v3.684c0 .315.256.571.572.571h3.683a.571.571 0 00.571-.571v-3.684a.571.571 0 00-.571-.571z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint2_linear_3_2)",
                        d: "M19.031 18.785h-2.97a.466.466 0 00-.467.466v2.971c0 .258.209.466.466.466h2.971a.466.466 0 00.466-.466v-2.971a.466.466 0 00-.466-.466z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E2048C",
                        d: "M15.85 0H9.67a.967.967 0 00-.967.967v6.18c0 .534.432.967.966.967h6.18a.967.967 0 00.967-.967V.967A.967.967 0 0015.85 0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint3_linear_3_2)",
                        d: "M15.498.448h-5.486a.861.861 0 00-.861.862v5.485c0 .476.386.862.861.862h5.486a.861.861 0 00.861-.862V1.31a.861.861 0 00-.862-.862z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_3_2",
                        x1: "9.573",
                        x2: "17.203",
                        y1: "12.28",
                        y2: "20.991",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.18",
                                stopColor: "#fff",
                                stopOpacity: "0.2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#168FCE",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_3_2",
                        x1: "0.817",
                        x2: "9.88",
                        y1: "4.096",
                        y2: "14.434",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.08",
                                stopColor: "#fff",
                                stopOpacity: "0.1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.7",
                                stopColor: "#231F20",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_3_2",
                        x1: "15.629",
                        x2: "18.583",
                        y1: "19.093",
                        y2: "21.642",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.03",
                                stopColor: "#fff",
                                stopOpacity: "0.9"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F3EA00",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_3_2",
                        x1: "10.162",
                        x2: "18.627",
                        y1: "5.679",
                        y2: "0.413",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.32",
                                stopColor: "#fff",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.99",
                                stopColor: "#E2048C",
                                stopOpacity: "0.7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_3_2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H317.502V25H0z"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/components/layouts/layouts.module.scss
var layouts_module = __webpack_require__(62676);
var layouts_module_default = /*#__PURE__*/__webpack_require__.n(layouts_module);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/wideformatprintercostsWrapper.tsx










const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
function WideFormatPrinterCostsWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Wide Format Printers",
                    domain: "WideFormatPrinterCosts.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Wide Format Printers",
                    domain: "WideFormatPrinterCosts.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                textColor: (wideformatprintercostsVariables_module_default()).offerCallNumber,
                slogan: " find the best wide format printer prices",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WideFormatPrinterCostsLogo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative w-screen",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (layouts_module_default())["wideformatprintercosts-gradient"],
                                children: children
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 62676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vpnpricecomparison-inner-body":"layouts_vpnpricecomparison-inner-body__GEXGI","background":"layouts_background__jUKkk","quoto-main-svg":"layouts_quoto-main-svg__A5TNP"};

/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 75321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blue":"#168fce","pink":"#e2048c","hoverBg":"#fef8fb"};

/***/ })

}]);